module.exports = __webpack_public_path__ + "img/aboutus03.b5c9762d.png";